import * as actionTypes from '../actions'

const initialState = {
  countries: []
}

const countryReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.GET_COUNTRIES: {
      return {
        ...state,
        countries: action.payload.countries,
      }
    }

    default: {
      return state
    }
  }
}

export default countryReducer
